export function useAnchor (): void {
  let anchors: NodeListOf<Element>

  function goToSection (x: Element, e: Event): void {
    e.preventDefault()

    const blockId = x.getAttribute('href')?.slice(1)

    if (blockId) {
      const item = document.getElementById(blockId)
      const offsetTop = item ? item.offsetTop - window.scrollY - 70 : 0

      window.scrollBy({ behavior: 'smooth', left: 0, top: offsetTop - document.body.scrollTop })
    }
  }

  onMounted(() => {
    anchors = document.querySelectorAll('a[href*="#anchor"]')

    anchors.forEach((x: Element): void => {
      x.addEventListener('click', (e: Event): void => goToSection(x, e))
    })
  })

  onUnmounted(() => {
    anchors.forEach((x: Element): void => {
      x.removeEventListener('click', (e: Event): void => goToSection(x, e))
    })
  })
}
